var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSitepoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.471 10.533l1.771 1.688 5.598 5.141 2.4-2.291a.804.804 0 00-.046-.985L9.99 12.184l.01-.005-2.371-2.266a.788.788 0 01.021-1.079l6.39-6.076L11.146 0 2.475 8.238a1.571 1.571 0 000 2.295zm19.056 2.937l-1.77-1.691-5.595-5.142-2.411 2.291a.773.773 0 00.045.985l2.205 1.891h-.006l2.369 2.265a.77.77 0 01-.029 1.064l-6.391 6.075L12.855 24l8.67-8.238a1.57 1.57 0 000-2.295z"
  })));
}

export default SvgSitepoint;